import {
  useCatalogProduct,
  type CatalogProductVariant,
} from "@babackapp/private-api-client/client/use-catalog-product";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { useState } from "react";
import { CatalogProductCombobox, type CatalogProductItem } from "../catalog-product-combobox";
import { CatalogVariantPicker } from "./catalog-variant-picker";

type Props = {
  shopId: string;
  isAdding: boolean;
  onAdd: (
    productTitle: string,
    variant: CatalogProductVariant,
    imageUrl: string | null,
  ) => void;
};

export function CatalogPickerAddView({ shopId, isAdding, onAdd }: Props) {
  const t = useCustomText();
  const [selected, setSelected] = useState<CatalogProductItem | null>(null);
  const { data: product } = useCatalogProduct(shopId, selected?.id ?? "");

  function handleAdd(variant: CatalogProductVariant, imageUrl: string | null) {
    if (!product) return;
    onAdd(product.title, variant, imageUrl);
    setSelected(null);
  }

  return (
    <div className="flex flex-col gap-4">
      <CatalogProductCombobox
        shopId={shopId}
        placeholder={t("catalogSearch.placeholder")}
        selected={selected}
        onSelectedChange={setSelected}
      />

      {selected && product && (
        <CatalogVariantPicker
          key={selected.id}
          product={product}
          fallbackImageUrl={selected.imageUrl ?? null}
          isAdding={isAdding}
          onAdd={handleAdd}
        />
      )}
    </div>
  );
}
